import {
  Button, Stack, Tooltip, Typography,
} from '@mui/joy';
import React from 'react';
import { useNonDesktopMode } from 'components/Responsive';
import { Link } from 'react-router-dom';
import Meta from 'components/Meta';
import TypeWriter from 'components/TypeWriter';
import errorRob from 'assets/errorRob.gif';

export default function NotFound() {
  const nonDesktop = useNonDesktopMode();

  const gifStyle = {
    width: 'min(80vw, 40vw)',
    height: 'auto',
  };

  return (
    <>
      <Meta title="Page not found" />
      <Stack
        direction={nonDesktop ? 'column' : 'row'}
        gap={10}
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <img src={errorRob} alt="Error" style={gifStyle} />
        <Stack
          gap={5}
          alignItems={nonDesktop ? 'center' : 'left'}
        >
          <Typography
            level="display1"
            fontSize="clamp(7rem, 20vw, 15rem)"
            textAlign={nonDesktop ? 'center' : 'left'}
            lineHeight={0.8}
            fontFamily='"Fira Code", monospace'
          >
            404
          </Typography>
          <Typography
            textAlign={nonDesktop ? 'center' : 'left'}
            level="h4"
            fontFamily='"Fira Code", monospace'
            fontSize="clamp(1rem, 7vw, 1.5rem)"
            fontWeight="300"
            width="min(90vw, 25rem)"
            minHeight="3em"
          >
            <TypeWriter typeInterval={20}>
              we could not find the page you&apos;re looking for.
            </TypeWriter>
          </Typography>
          <Stack direction="row" gap={2} alignSelf="stretch" flexWrap="wrap" padding={nonDesktop ? 1 : 0}>
            <Button
              component={Link}
              // to="https://github.com/BSoDium/bsodium.fr/issues/new?assignees=BSoDium&labels=bug&projects=&template=bug_report.md"
              to="https://github.com/it's-private-fornow-🤪"
              target="_blank"
              size="lg"
              variant="outlined"
              color="neutral"
              sx={{
                flex: 1,
                whiteSpace: 'nowrap',
              }}
            >
              lmk abt this bug
            </Button>
            <Tooltip title="🇪🇬🇪🇬" variant="soft">
              <Button
                component={Link}
                to="/"
                size="lg"
                variant="solid"
                color="success"
                sx={{
                  flex: 1,
                  whiteSpace: 'nowrap',
                }}
              >
                take me home
              </Button>
            </Tooltip>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
